import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@400;500;600&display=swap');

  .cs-page {
    background: #ffffff;
    color: #111111;
    font-family: 'DM Sans', sans-serif;
    min-height: 100vh;
    padding: 0;
  }

  .cs-back {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #888;
    background: none;
    border: none;
    cursor: pointer;
    transition: color 0.2s;
    text-decoration: none;
  }

  .cs-back:hover { color: #111; }

  .cs-back svg {
    transition: transform 0.2s;
  }

  .cs-back:hover svg {
    transform: translateX(-3px);
  }

  .cs-hero {
    padding: 5rem 3rem 3rem;
    max-width: 1000px;
    margin: 0 auto;
  }

  .cs-eyebrow {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #C9A84C;
    margin-bottom: 1rem;
  }

  .cs-title {
    font-family: 'Bebas Neue', sans-serif;
    font-size: clamp(64px, 10vw, 110px);
    line-height: 1;
    letter-spacing: 4px;
    color: #111;
    margin-bottom: 0.5rem;
    white-space: nowrap;
  }

  .cs-title-outline {
    -webkit-text-stroke: 2px #111;
    color: transparent;
  }

  .cs-subtitle {
    font-size: 14px;
    color: #888;
    margin-top: 1.25rem;
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .cs-subtitle a {
    color: #C9A84C;
    text-decoration: none;
    font-weight: 600;
  }

  .cs-subtitle a:hover { text-decoration: underline; }

  .cs-dot {
    width: 4px;
    height: 4px;
    background: #ccc;
    border-radius: 50%;
    display: inline-block;
  }

  .cs-stats-bar {
    max-width: 1000px;
    margin: 3rem auto 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    border: 1px solid #111;
  }

  .cs-stat {
    padding: 1.75rem 2rem;
    border-right: 1px solid #111;
    animation: fadeUp 0.6s ease both;
  }

  .cs-stat:last-child { border-right: none; }

  .cs-stat-label {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    color: #888;
    margin-bottom: 8px;
  }

  .cs-stat-value {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 36px;
    color: #111;
    line-height: 1;
  }

  .cs-stat-value span { color: #C9A84C; }

  .cs-body {
    max-width: 1000px;
    margin: 0 auto;
    padding: 4rem 3rem;
  }

  .cs-divider {
    border: none;
    border-top: 1px solid #eee;
    margin: 3rem 0;
  }

  .cs-section-label {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #C9A84C;
    margin-bottom: 1.25rem;
  }

  .cs-two-col {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 3rem;
    margin-bottom: 3rem;
  }

  .cs-block-title {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 32px;
    color: #111;
    letter-spacing: 1px;
    margin-bottom: 0.75rem;
  }

  .cs-block-body {
    font-size: 14px;
    color: #555;
    line-height: 1.8;
  }

  .cs-note {
    border-left: 3px solid #C9A84C;
    padding: 1.25rem 1.75rem;
    background: #fafafa;
    margin-bottom: 3rem;
  }

  .cs-note p {
    font-size: 14px;
    color: #555;
    line-height: 1.8;
    font-style: italic;
  }

  .cs-deliverables {
    margin-bottom: 3rem;
  }

  .cs-del-item {
    display: flex;
    align-items: flex-start;
    gap: 1.5rem;
    padding: 1.25rem 0;
    border-bottom: 1px solid #f0f0f0;
    transition: background 0.2s;
  }

  .cs-del-item:first-child { border-top: 1px solid #f0f0f0; }

  .cs-del-num {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 20px;
    color: #C9A84C;
    min-width: 32px;
    padding-top: 1px;
  }

  .cs-del-text {
    font-size: 14px;
    color: #444;
    line-height: 1.7;
  }

  .cs-del-text strong {
    color: #111;
    font-weight: 600;
  }

  .cs-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 3rem;
  }

  .cs-tag {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    padding: 6px 14px;
    border: 1px solid #111;
    color: #111;
  }

  .cs-tag.gold {
    border-color: #C9A84C;
    color: #C9A84C;
  }

  .cs-role-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-bottom: 3rem;
  }

  .cs-role-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0.875rem 1.25rem;
    border: 1px solid #eee;
    transition: border-color 0.2s, background 0.2s;
  }

  .cs-role-item:hover {
    border-color: #C9A84C;
    background: #fffdf5;
  }

  .cs-role-dot {
    width: 6px;
    height: 6px;
    background: #C9A84C;
    flex-shrink: 0;
  }

  .cs-role-text {
    font-size: 13px;
    color: #333;
  }

  .cs-cta-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin-top: 3rem;
  }

  .cs-btn-primary {
    background: #111;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    padding: 16px 32px;
    border: 2px solid #111;
    cursor: pointer;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: background 0.2s, color 0.2s;
  }

  .cs-btn-primary:hover {
    background: #C9A84C;
    border-color: #C9A84C;
    color: #fff;
  }

  .cs-btn-outline {
    background: #fff;
    color: #111;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    padding: 16px 32px;
    border: 2px solid #111;
    cursor: pointer;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: background 0.2s, color 0.2s;
  }

  .cs-btn-outline:hover {
    background: #111;
    color: #fff;
  }

  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(20px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .fade-up {
    opacity: 0;
    animation: fadeUp 0.6s ease forwards;
  }

  .delay-1 { animation-delay: 0.1s; }
  .delay-2 { animation-delay: 0.2s; }
  .delay-3 { animation-delay: 0.3s; }
  .delay-4 { animation-delay: 0.4s; }

  @media (max-width: 768px) {
    .cs-nav { padding: 1.25rem 1.5rem; }
    .cs-hero { padding: 3rem 1.5rem 2rem; }
    .cs-body { padding: 2rem 1.5rem; }
    .cs-stats-bar { grid-template-columns: 1fr; }
    .cs-stat { border-right: none; border-bottom: 1px solid #111; }
    .cs-stat:last-child { border-bottom: none; }
    .cs-two-col { grid-template-columns: 1fr; gap: 2rem; }
    .cs-role-grid { grid-template-columns: 1fr; }
  }
`;

const deliverables = [
  {
    num: "01",
    title: "Home page",
    desc: "Hero section, animated stats counter, 'Why Choose Us' features, category slider, how-it-works flow, testimonials, and blog section"
  },
  {
    num: "02",
    title: "Service-A-Sure page",
    desc: "Dedicated service guarantee page explaining Ispick's quality promise to users"
  },
  {
    num: "03",
    title: "About Us page",
    desc: "Company mission, vision, and four core values — Honesty, Transparency, Integrity, Ethical Conduct"
  },
  {
    num: "04",
    title: "Contact page",
    desc: "Support email, phone number, registered & communication address with clean layout"
  },
  {
    num: "05",
    title: "Privacy Policy & Terms of Use",
    desc: "Legally formatted, properly structured compliance pages"
  },
  {
    num: "06",
    title: "landing page",
    desc: "Designed a dedicated landing page with first-order discount offer to drive app bookings"
  }
];

const techStack = ["WordPress", "Elementor", "Custom CSS", "Responsive Design"];
const techGold = ["Google Tag Manager", "SEO Optimization"];

const roles = [
  "Pixel-perfect design implementation",
  "WordPress & Elementor development",
  "Mobile & tablet responsiveness",
  "Client communication & revisions",
  "Content & media integration",
  "Testing & live deployment"
];

export default function IspickCaseStudy() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <style>{styles}</style>
      <div className="cs-page">

        <Navbar />

        <section className="cs-hero">
          <p className="cs-eyebrow fade-up delay-1">Case Study · 2026</p>
          <div className="cs-title fade-up delay-2">
            IS<span className="cs-title-outline">PICK</span>
          </div>
          <div className="cs-subtitle fade-up delay-3">
            <span>Website Redevelopment</span>
            <span className="cs-dot"></span>
            <span>Hodek Edge Pvt. Ltd., Pune</span>
            <span className="cs-dot"></span>
            <a href="https://ispick.com" target="_blank" rel="noreferrer">ispick.com ↗</a>
          </div>
        </section>

        <div className="cs-stats-bar">
          <div className="cs-stat fade-up delay-2">
            <div className="cs-stat-label">Duration</div>
            <div className="cs-stat-value">1 <span>Mo</span></div>
          </div>
          <div className="cs-stat fade-up delay-3">
            <div className="cs-stat-label">Pages built</div>
            <div className="cs-stat-value">6 <span>Pg</span></div>
          </div>
          <div className="cs-stat fade-up delay-4">
            <div className="cs-stat-label">Project type</div>
            <div className="cs-stat-value">RE<span>DEV</span></div>
          </div>
        </div>

        <div className="cs-body">

          <div className="cs-two-col">
            <div>
              <p className="cs-section-label">The problem</p>
              <h2 className="cs-block-title">Outdated & unconvincing</h2>
              <p className="cs-block-body">
                Ispick's old website failed to communicate the value of their home services app — poor layout, no clear user journey, and weak calls-to-action that didn't drive app downloads.
              </p>
            </div>
            <div>
              <p className="cs-section-label">The solution</p>
              <h2 className="cs-block-title">Full redevelopment</h2>
              <p className="cs-block-body">
                Rebuilt the entire website in WordPress using Elementor — translating client-provided designs into a pixel-perfect, fully responsive site with a clear, conversion-focused layout.
              </p>
            </div>
          </div>

          <div className="cs-note">
            <p>
              Designs were provided by the client. My responsibility was pixel-perfect implementation — ensuring every section looked exactly as designed across all screen sizes, with zero compromise on detail.
            </p>
          </div>

          <p className="cs-section-label">What I delivered</p>
          <div className="cs-deliverables">
            {deliverables.map((d) => (
              <div className="cs-del-item" key={d.num}>
                <span className="cs-del-num">{d.num}</span>
                <p className="cs-del-text">
                  <strong>{d.title} — </strong>{d.desc}
                </p>
              </div>
            ))}
          </div>

          <hr className="cs-divider" />

          <p className="cs-section-label">Tech stack</p>
          <div className="cs-tags">
            {techStack.map((t) => (
              <span className="cs-tag" key={t}>{t}</span>
            ))}
            {techGold.map((t) => (
              <span className="cs-tag gold" key={t}>{t}</span>
            ))}
          </div>

          <p className="cs-section-label">My role</p>
          <div className="cs-role-grid">
            {roles.map((r) => (
              <div className="cs-role-item" key={r}>
                <span className="cs-role-dot"></span>
                <span className="cs-role-text">{r}</span>
              </div>
            ))}
          </div>

          <hr className="cs-divider" />

          <div className="cs-cta-row">
            <a
              href="https://ispick.com"
              target="_blank"
              rel="noreferrer"
              className="cs-btn-primary"
            >
              View live site ↗
            </a>
            <button className="cs-btn-outline" onClick={() => navigate("/projects")}>
              ← Back to projects
            </button>
          </div>

        </div>
      </div>
    </>
  );
}